// eslint-disable-next-line
// @ts-nocheck
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import { blue, red } from '@mui/material/colors';
import {
  getServiceProviderDetails,
  getServiceProviderTotalRecords,
  setServiceProvider,
} from '../../store/state/serviceProviderSlice';
import {
  useGetAllServiceProviderDetailMutation,
  useDeleteServiceProviderDetailMutation,
} from '../../store/api/serviceProviderApi';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { sr } from 'date-fns/locale';
import { commission as commissions } from '../../_mock/bookings';
import {
  useDeleteParkingSpaceLocationByIdMutation,
  useGetAllParkingSpaceLocationMutation,
} from '../../store/api/parkingsApi';
import { getParkingSpaces, getParkingTotalRecords, setParkings } from '../../store/state/parkingSlice';
import setISODay from 'date-fns/fp/setISODay/index';
// ----------------------------------------------------------------------

const TABLE_HEAD_VENDOR = [
  { id: 'name', label: "Vendor's Name", alignRight: false },
  { id: 'contactNumber', label: 'Contact', alignRight: false },
  { id: 'tierType', label: 'Tier type', alignRight: false },
  { id: 'commission', label: 'Commission', alignRight: false },
  { id: '' },
];

const TABLE_HEAD_PARKING = [
  { id: 'name', label: 'Parking Space Name', alignRight: false },
  { id: 'vendorName', label: 'Vendor name', alignRight: false },
  { id: 'tierType', label: 'Tier type', alignRight: false },
  { id: 'commission', label: 'Commission', alignRight: false },
  { id: '' },
];

export default function CommissiomManagement() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [commissionDataVendor, setCommissionDataVendor] = useState([]);
  const [commissionDataParking, setCommissionDataParking] = useState([]);
  const [getAllServiceProviderDetail, serviceProviderResponse] = useGetAllServiceProviderDetailMutation();
  const [getAllParkingSpaceLocation, getAllParkingSpaceLocationResponse] = useGetAllParkingSpaceLocationMutation();
  const [deleteServiceProviderDetail, deleteResponse] = useDeleteServiceProviderDetailMutation();
  const [deleteParkingSpaceLocationById, deleteParkingResponse] = useDeleteParkingSpaceLocationByIdMutation();
  const serviceProviderData = useAppSelector(getServiceProviderDetails);
  const serviceProviderTotalRecords = useAppSelector(getServiceProviderTotalRecords);
  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const parkingSpacesTotalRecords = useAppSelector(getParkingTotalRecords);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [filterVendorName, setFilterVendorName] = useState('');
  const [filterParkingName, setFilterParkingName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteId, setDeleteId] = useState<number>();
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const filteredVendors = commissionDataVendor;
  const filteredParkings = commissionDataParking;
  const isVendorNotFound = filteredVendors.length === 0;
  const isParkingNotFound = filteredParkings.length === 0;

  useEffect(() => {
    if (serviceProviderData) {
      setCommissionDataVendor(serviceProviderData);
      setValue(parseInt(searchParams.get('view_type') || 0));
    }
  }, [serviceProviderData]);

  useEffect(() => {
    if (parkingSpacesData) {
      setCommissionDataParking(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  const getAllServiceProviderDetailAsync = async (offset, page, order, name) => {
    await getAllServiceProviderDetail({
      token: token.token,
      payload: {
        offset: offset,
        page: page,
        order: order,
        columnName: name,
      },
    });
  };

  const getAllParkingSpaceLocationAsync = async (offset, page, order, name = '') => {
    await getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        offset: offset,
        page: page,
        orderBy: order,
        name: name,
      },
    });
  };

  useEffect(() => {
    getAllServiceProviderDetailAsync(rowsPerPage, page, order);
    getAllParkingSpaceLocationAsync(rowsPerPage, page, order);
  }, []);

  useEffect(() => {
    if (serviceProviderResponse.isSuccess) {
      dispatch(setServiceProvider(serviceProviderResponse.data));
    }
  }, [serviceProviderResponse.isSuccess]);

  useEffect(() => {
    if (getAllParkingSpaceLocationResponse.isSuccess) {
      dispatch(setParkings(getAllParkingSpaceLocationResponse.data));
    }
  }, [getAllParkingSpaceLocationResponse.isSuccess]);

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllServiceProviderDetail({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, orderBy: order },
      });
      toast.success('Vendor updated successfully.');
    }
    if (deleteParkingResponse.isSuccess) {
      getAllParkingSpaceLocation({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
        },
      });
      toast.success('Parking updated successfully');
    }
  }, [deleteResponse.isSuccess, deleteParkingResponse.isSuccess]);

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handleChange = (event, newValue) => {
    searchParams.set('view_type', value === 0 ? 1 : 0);
    setSearchParams(searchParams);
    setValue(newValue);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (value === 0) {
      getAllServiceProviderDetailAsync(rowsPerPage, newPage, order);
    } else {
      getAllParkingSpaceLocationAsync(rowsPerPage, newPage, order);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (value === 0) {
      getAllServiceProviderDetailAsync((event.target.value, 10), 0, order);
    } else {
      getAllParkingSpaceLocationAsync((event.target.value, 10), 0, order);
    }
  };

  const handleFilterByVendorName = (event) => {
    setPage(0);
    setFilterVendorName(event.target.value);
    getAllServiceProviderDetailAsync(rowsPerPage, page, order, event.target.value);
  };

  const handleFilterByParkingName = (event) => {
    setPage(0);
    setFilterParkingName(event.target.value);
    getAllParkingSpaceLocationAsync(rowsPerPage, page, order, event.target.value);
  };

  const handleServiceProviderDelete = () => {
    setOpen(false);
    deleteServiceProviderDetail({
      id: deleteId,
      token: token.token,
    });
  };

  const handleParkingDelete = () => {
    setOpen(false);
    deleteParkingSpaceLocationById({
      id: deleteId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Comission Management">
      <Container>
        <Box
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          marginBottom={'25px'}
        >
          <Typography variant="h4">Commission Management By {value ? 'Parking Space' : 'Vendor'}</Typography>
          <Stack direction="row" alignItems="center" justifyContent="flex-start">
            <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
              <LinkTab label="Set by Vendor" />
              <LinkTab label="Set by Parking Space" />
            </Tabs>
          </Stack>
        </Box>
        {value === 0 ? (
          <Card>
            <BookingListToolbar filterVendorName={filterVendorName} onFilterName={handleFilterByVendorName} />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD_VENDOR}
                    rowCount={commissionDataVendor.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredVendors.length > 0 &&
                      filteredVendors.map((row) => {
                        const { id, name, emailId, contactNumber, userId, status, tierType, commission, merchantId } =
                          row;
                        return (
                          <TableRow hover key={id.toString()} tabIndex={-1} role="checkbox">
                            <TableCell align="left">
                              <Typography
                                fontWeight="bold"
                                variant="subtitle2"
                                onClick={() => {
                                  navigate('/dashboard/add-commission', {
                                    state: {
                                      editData: row,
                                      isEditVendor: true,
                                    },
                                  });
                                }}
                                style={{
                                  color: 'blue',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="bold" variant="subtitle2">
                                {contactNumber}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="bold" variant="subtitle2">
                                {tierType}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="bold" variant="subtitle2">
                                {commission}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center">
                                <Switch
                                  checked={status}
                                  onClick={() => {
                                    setDeleteId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isVendorNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterVendorName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={serviceProviderTotalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        ) : (
          <Card>
            <BookingListToolbar filterParkingName={filterParkingName} onFilterName={handleFilterByParkingName} />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD_PARKING}
                    rowCount={commissionDataParking.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredParkings.length > 0 &&
                      filteredParkings.map((row) => {
                        const {
                          id,
                          name,
                          status,
                          serviceProviderDetailResponseDTO,
                          tierType,
                          commission,
                          merchantId,
                          userId,
                        } = row;
                        return (
                          <TableRow hover key={id.toString()} tabIndex={-1} role="checkbox">
                            <TableCell align="left">
                              <Typography
                                fontWeight="bold"
                                variant="subtitle2"
                                onClick={() => {
                                  navigate('/dashboard/add-commission', {
                                    state: {
                                      editData: row,
                                      isEditVendor: false,
                                    },
                                  });
                                }}
                                style={{
                                  color: 'blue',
                                  cursor: 'pointer',
                                }}
                              >
                                {name}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="bold" variant="subtitle2">
                                {serviceProviderDetailResponseDTO?.name}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="bold" variant="subtitle2">
                                {tierType}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="bold" variant="subtitle2">
                                {commission}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center">
                                <Switch
                                  checked={status}
                                  onClick={() => {
                                    setDeleteId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isParkingNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterParkingName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={parkingSpacesTotalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}

        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button variant="contained" onClick={cancelDelete} sx={{ margin: '10px' }} color="error">
                  No
                </Button>
                <Button variant="contained" onClick={handleServiceProviderDelete} sx={{ margin: '10px' }}>
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}

        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button variant="contained" onClick={cancelDelete} sx={{ margin: '10px' }} color="error">
                  No
                </Button>
                <Button variant="contained" onClick={handleParkingDelete} sx={{ margin: '10px' }}>
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}
        {serviceProviderResponse.isLoading ||
        deleteResponse.isLoading ||
        getAllParkingSpaceLocationResponse.isLoading ? (
          <Loading />
        ) : null}
      </Container>
    </Page>
  );
}
